import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommunicationRoutingModule } from './communication-routing.module';
import { CommunicationTypeComponent } from './communication-type/communication-type.component';
import { CommunicationComponent } from './communication/communication.component';
import { CommuncationDocumentComponent } from './communcation-document/communcation-document.component';
import { DocumentsUploadingComponent } from './documents-uploading/documents-uploading.component';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { QuestionAnswerComponent } from './question-answer/question-answer.component';
import { ThoughtDayComponent } from './thought-day/thought-day.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxEditorModule } from 'ngx-editor';
import { ExamAlertComponent } from './exam-alert/exam-alert.component';


@NgModule({
  declarations: [CommunicationTypeComponent, CommunicationComponent, CommuncationDocumentComponent, 
    DocumentsUploadingComponent, QuestionAnswerComponent, ThoughtDayComponent, ExamAlertComponent],
  imports: [
    CommonModule,
    CommunicationRoutingModule,
    AdminModule,
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
  ]
})
export class CommunicationModule { }
